import { IRequestComboActividadPorEquipo } from "../../Interfaces/IIPERC";
import { fetchIPERC } from "../http-common";

const postComboActividadPorEquipo = (
  body: IRequestComboActividadPorEquipo,
  controller = new AbortController()
) => {
  return fetchIPERC.post(`Actividad/ListarPorEquipo`, body, {
    signal: controller.signal,
  });
};

const postTableActividades = (
  controlle = new AbortController()
) => {
  return fetchIPERC.get(`Actividad/Listar`,
    {
      signal: controlle.signal,
    })
}

const getActividadesPorEquipo = (EquipoId: string
) => {
  return fetchIPERC.get(`Actividad/${EquipoId}`,)
}

const postCrearActividad = (data: any
) => {
  return fetchIPERC.post(`Actividad`, data)
}

const putActualizarNombreActividad = (
  data: any,
) => {
  return fetchIPERC.put(`Actividad/ActualizarNombre`, data);
};

const ActividadService = {
  postComboActividadPorEquipo,
  postTableActividades,
  getActividadesPorEquipo,
  postCrearActividad,
  putActualizarNombreActividad,
};
export default ActividadService;
